import { NgModule } from '@angular/core';
import { DomSanitizerModule } from '@epicuro-next/ataraxia/dom-sanitizer';
import {
  EnvironmentSettings,
  ENVIRONMENT_SETTINGS,
} from '@epicuro-next/platform/environment';

import { THIRD_PARTY_SCRIPTS_CONFIG_TOKEN } from '../tokens';

import { IThirdPartyScriptsConfig } from './interfaces/scripts.config';
import { ScriptsInjectorService } from './services/scripts-injector.service';

export function getConfig(
  environmentSettings: EnvironmentSettings,
): IThirdPartyScriptsConfig | null {
  if (!environmentSettings.thirdPartyScripts) {
    return null;
  }

  let config: IThirdPartyScriptsConfig | null = null;
  if (environmentSettings.thirdPartyScripts) {
    try {
      config = JSON.parse(environmentSettings.thirdPartyScripts);
    } catch (exception) {
      console.warn(
        'Could not parse the configuration for third party scripts config',
        { exception, config: environmentSettings.thirdPartyScripts },
      );
    }
  }

  return config;
}

@NgModule({
  imports: [DomSanitizerModule],
  providers: [
    {
      provide: THIRD_PARTY_SCRIPTS_CONFIG_TOKEN,
      useFactory: getConfig,
      deps: [ENVIRONMENT_SETTINGS],
    },
    ScriptsInjectorService,
  ],
})
export class ThirdPartyScriptsModule {}
